<atx-language-selector
  [activeLanguage]="selectedLanguage$ | async"
  [languages]="availableLanguages$ | async"
  (selectLanguage)="setLanguage($event)"
></atx-language-selector>
